export const FIND_POOL_REQUESTS_FAILURE = 'FIND_POOL_REQUESTS_FAILURE';

export const findPoolRequestsFailure = ({ error, request }) => ({
    type: FIND_POOL_REQUESTS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});